import { createFFmpeg, fetchFile } from '@ffmpeg/ffmpeg';
const resolveURL = require('resolve-url');
const mimeType = 'video/webm;codecs=H264';
const ext = 'mp4';
const time = 10000;
const type = 'video/mp4';

export default class Record {
    constructor() {
        this.handler;
        this.recorder;
        this.recordingData = new Array();
    }

    init(handler) {
        this.handler = handler;
    }

    // 녹화 여부 
    isRecording() {
        return this.recoder && this.recoder.state === 'recording' ? true : false;
    }

    // 시작
    start(stream) {
        let recordingData = this.recordingData;
        const handlerRecordData = (data) => this.setRecordData(data);
        try {
            const recorder = new MediaRecorder(stream, { mimeType, videoBitsPerSecond: 8000000 });
            const handler = this.handler;

            // 녹화 시작 
            recorder.onstart = () => handler.start();

            // 녹화 데이터 
            recorder.ondataavailable = e => {
                if (e.data && e.data.size > 0) {
                    handlerRecordData(e.data);

                    handler.save(e.data);
                }
            }

            // 녹화 종료 
            recorder.onstop = (e) => handler.stop();

            recorder.start(time);           

            this.recoder = recorder;
        } catch (e) {
            this.handler.stop();
        }
    }
    
    // stop 
    stop() {
        this.recoder && this.recoder.stop();
    }

    setRecordData(data) {
        this.recordingData.push(data);
    }

    // 파일 저장 
    getSaveFile(filename, data) {
        if (data) {
            this.handleConvertStarted(data, filename);
        } else if (this.recordingData && this.recordingData.length > 0) {
            const blob = new Blob(this.recordingData, {type: 'video/webm'});
            this.handleConvertStarted(blob, filename);
            this.recordingData = [];
        }            
    }

    async initFFMPEG() {
        const ffmpeg = createFFmpeg({
            log: process.env.FFMPEG_ENV === 'development' ? true : false,
            corePath: resolveURL('/libs/ffmpeg-core.js')
        });

        if (ffmpeg.isLoaded() === false) await ffmpeg.load();

        return ffmpeg;
    }

    // FFMPEG 변환 
    async handleConvertStarted(videoFile, filename) {
        const defer = [];
        const ffmpeg = await this.initFFMPEG();
        try {
            const inputURL = URL.createObjectURL(videoFile);
            defer.push(() => {
                URL.revokeObjectURL(inputURL);
            });

            ffmpeg.FS("writeFile", "input.webm", await fetchFile(inputURL));
            defer.push(() => {
                ffmpeg.FS("unlink", "input.webm");
            });
        
            await ffmpeg.run("-i", "input.webm", "-strict", "experimental", "-crf", "1", "-c:v", "copy", "-c:a", "libfdk_aac", "-b:a", "384k", `output.${ext}`);
            defer.push(() => {
                ffmpeg.FS("unlink", `output.${ext}`);
            });
        
            const outputFile = ffmpeg.FS("readFile", `output.${ext}`);
            const outputBlob = new Blob([outputFile], { type });
            const outputURL = URL.createObjectURL(outputBlob);
            defer.push(() => {
                URL.revokeObjectURL(outputURL);
            })
        
            const link = document.createElement("a");
            link.href = outputURL;
            link.download = `${filename}.${ext}`;
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (err) {
            console.error(err);
        } finally {
            defer.forEach(fn => {
                fn();
            });
        }
    }
} 